module.exports = __webpack_public_path__ + "img/ivy-pic2.7275cfd7.png";